export default {
    section: 'Section 9: Additional Information',
    name: 'additional-info',
    items: [
        {
            text: 'Please provide additional information about your business that has not been represented in this questionnaire.',
            type: 'textarea',
            name: 'additional-info',
            props: {}
        },
        {
            text: 'Please include any additional files that are relevant for the valuation.',
            type: 'data-table',
            name: 'additional-files',
            props: {
                headers: [
                    {
                        text: 'File Name',
                        value: 'filename'
                    },
                    {
                        text: 'File Size',
                        value: 'filesize'
                    }
                ],
                isFileUpload: true,
                newItemLabel: 'Upload a File',
                noDataLabel: 'Please Upload Any Additional Files'
            }
        }
    ]
};


// WEBPACK FOOTER //
// ./src/components/valuation/valuation-data/additional-info.js